import { cx } from "@/utils";

interface PaginationProps {
  className?: string;
  max?: number;
  disabled?: boolean;
  current?: number;
  next?: () => void;
  previous?: () => void;
  formatLabel?: (args: { max: number; pageNumber: number }) => string;
  showRest?: boolean;
}

import ChevronLeft from "@/assets/icons/chevron-left.svg";
import ChevronRight from "@/assets/icons/chevron-right.svg";
import { FILTER } from "@/constants";
import useFilterParams from "@/hooks/useFilterParams";
import Clickable from "@components/Clickable";

import styles from "./Pagination.module.css";

const Pagination: React.FC<PaginationProps> = ({
  className,
  max,
  disabled,
  current,
  formatLabel,
  next: passedNext,
  previous: passedPrevious,
  showRest = true,
}) => {
  const [{ [FILTER.PAGE]: filterPage }, setFilters] = useFilterParams();
  const pageNumber = current || filterPage || 1;

  if (!max || max === 1) return null;

  const previous = () => {
    setFilters({ [FILTER.PAGE]: pageNumber - 1 });
  };

  const next = () => {
    setFilters({ [FILTER.PAGE]: pageNumber + 1 });
  };

  return (
    <nav
      data-testid="pagination"
      className={cx(className, styles.root, {
        [styles.disabled]: disabled,
      })}
    >
      <Clickable
        data-testid="pagination-previous"
        disabled={disabled || pageNumber === 1}
        className={cx(styles.item, { [styles.disabled]: pageNumber === 1 })}
        onClick={passedPrevious || previous}
      >
        <ChevronLeft stroke="currentColor" width="1em" />
      </Clickable>
      <div
        className={cx(styles.item, styles.display)}
        data-testid="pagination-label"
      >
        {formatLabel
          ? formatLabel({ max, pageNumber })
          : showRest
            ? `${L.MENTIONS_VIEW_PAGINATION_PAGE} ${pageNumber} ${L.MENTIONS_VIEW_PAGINATION_OF} ${max}`
            : `${L.MENTIONS_VIEW_PAGINATION_PAGE} ${pageNumber}`}
      </div>
      <Clickable
        data-testid="pagination-next"
        disabled={disabled || pageNumber === max}
        onClick={passedNext || next}
        className={cx(styles.item, {
          [styles.disabled]: disabled || pageNumber === max,
        })}
      >
        <ChevronRight stroke="currentColor" width="1em" />
      </Clickable>
    </nav>
  );
};

export default Pagination;
